import {_} from "backboneAdapter";
import moment from 'moment';
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import UserModel from 'js/models/userrelatedinfo.model';
import Template from 'js/templates/navbar.hbs';
import i18n from 'l10n';
import dhtmlx from 'dhtmlxAdapter';
import creditsTileView from 'js/views/credits-tile-simpleview';
import NotificationsNavbarView from 'js/views/notifications-navbar.view';
import {el, handles, on, tagName, template} from "../adapters/backbone-decorators";

@el(".main-menu-wrapper")
@tagName("span")
@template(Template)
class NavbarView extends GenericView {

    constructor(options) {
        super(options);

        this.notificationsView = null;
        this.model = new UserModel();
        this.model.bind("reset add remove", this.loadUser, this);
        this.loadUser().then(()=>console.log("User loaded."));

        const source = new EventSource('/CampaignCloud/events');

        source.addEventListener('open', () => console.log('connected'));
        source.addEventListener('message', ({data}) => {
            const parsedData = JSON.parse(data);
            const {jsonClass, importContactType, filename, title, text} = parsedData;
            if (["ImportContactsEvent", "ParseContactsEvent"].includes(jsonClass)) {
                if (!['Yahoo', 'Hotmail', 'Facebook'].includes(importContactType)) {
                    const uploadFile = filename || importContactType || '(paste)';
                    const retrievedItem = window.sessionStorage.getItem(uploadFile);
                    const existingInfo = retrievedItem ? JSON.parse(retrievedItem) : {};

                    _.extend(existingInfo, parsedData);
                    window.sessionStorage.setItem(uploadFile, JSON.stringify(existingInfo));
                    this.trigger("progress:contactsImport", existingInfo);
                }
            } else if (jsonClass === "SpamScoreEvent") {
                this.trigger("spamResult", parsedData);
            } else if (jsonClass === "ManualNotification") {
                $.Notify.show(text);
            } else {
                const decodedTitle = decodeURIComponent(title.replace(/\+/g, " "));
                const translatedTitle = decodedTitle === "noTitle" ? i18n.t("noTitle") : decodedTitle;
                // const markup = $("<span/>").text(translatedTitle)[0].outerHTML; //for JS injection
                $.Notify.show(i18n.t(`system.${jsonClass}`, {id: translatedTitle}));

                this.trigger("changed:campaignStatus", parsedData);
            }
            console.log(data);
        }, false);
        source.addEventListener('error', e => console.info("event source connection dropped"), false);
        window.onbeforeunload = e => source.close();
        $(document).ready(() => $("#geo-tile").on('click', this.goToContactsMap));
    }

    render() {
        super.render();

        $.Metro.initDropdowns(this.$el);
        var self = this;
        const title = $("title").text();
        this.$("#current-page-title").text(title);
        if (title === i18n.t("servicestitle")) {
            this.$("#current-page-title").css("cursor", "pointer");
            this.$("#current-page-title").click(() => {
                window.location = "/CampaignCloud/cloudui/home/Service.htm#type/all";
            });
        }
        if (title === i18n.t("messagetitle")) {
            this.$("#current-page-title").css("cursor", "pointer");
            this.$("#current-page-title").click(() => {
                window.location = "/CampaignCloud/cloudui/home/Message.htm";
            });
        }
        this.$('#language-selector li a').each(function (a) {
            self.$(this).click(function (e) {
                e.preventDefault();
                var lang = self.$(this).data("lang");
                i18n.changeLanguage(lang).then(() => location.reload());
            });
        });
        creditsTileView.init('.credits-tile');
    }

    @on('click #menuLogo')
    toggleSideNav(event) {
        event.preventDefault();
        const $menu = this.$(".sidenav");
        if ($menu.hasClass("open"))
            $menu.removeClass("open");
        else
            $menu.addClass("open");
    }

    @handles("changed:user")
    @handles("app.loadUser")
    async loadUser() {

        console.info("Fetching user");
        try {
            await this.model.fetch();
            var name = this.model.myName();
            this.model.set({
                displayName: name,
                newNotifications: 0
            });
            this.render();

            this.notificationsView = new NotificationsNavbarView();

            $("#username-for-display").text(this.model.get("displayName"));
            $(".usericon-for-display").html(Handlebars.helpers.contacticon({
                subscriber: {
                    firstName: this.model.get("firstName"),
                    lastName: this.model.get("lastName")
                },
                email: this.model.get("email"),
                msisdn: this.model.get("phone"),
                username: this.model.get("username")
            }, {
                hash: {
                    size: 80,
                    class: "profileiconbig"
                }
            }).toString());
            var lastLoginMillis = this.model.get("lastLogin") ? this.model.get("lastLogin").millis : null;
            /*
             * In case of a new user the lastLogin value would be null.
             */
            if (lastLoginMillis)
                $("#last-login-for-display").text(i18n.t("appuseraction.lastlogin") + " "
                    + Handlebars.helpers.timestamp(lastLoginMillis, "L"));

            var $span = $("<span/>");
            $span.html("<b style='font-weight: normal;'>" + i18n.t("credits.accountType") + "</b> <span style='text-transform: capitalize'>" + Handlebars.helpers.planTypeHelper(this.model.get("subscriptionLevel")));

            $("#plan-type").empty();
            $("#plan-type").append($span);

            if (!this.model.get("postpaid")) {
                $span = $("<span/>");
                $span.html("<b>" + i18n.t("credits.creditstitle") + "</b> " + this.model.get("creditsAvailable").toFixed(2));

                $("#credits-title").empty();
                $("#credits-title").append($span);

                $span = $("<span/>");
                var expiresOnValue = this.model.get("expirationDate") ? Handlebars.helpers.timestamp(this.model.get("expirationDate").millis, "L HH:mm") : i18n.t("never");
                $span.html("<b>" + i18n.t("credits.expiringon") + "</b> " + expiresOnValue);

                $("#expiration-date-show").empty();
                $("#expiration-date-show").append($span);

                if (this.model.get("subscriptionLevel") < 4 && !this.model.get("postpaid")) {
                    $('#upgrade-link').text(i18n.t("profile.upgradeaccount"));

                }
            }
            else {
                $.each($(".accountInfo"), function() {
                    $(this).remove();
                });

            }

            if(this.model.get("contactLimit")) {
                $span = $("<span/>");
                $span.html("<b>" + i18n.t("subscriber.contactLimit") + ":</b> " + Handlebars.helpers.beatifyNumber(this.model.get("contactLimit")));

                $("#contactLimit").empty();
                $("#contactLimit").append($span);
            }

            var subscriptionLevel = this.model.get("subscriptionLevel");
            if (subscriptionLevel === 1 && document.cookie.toString().indexOf("isTrialAccount") === -1) {
                const dateToExpireCookie = moment().add(1, 'days');
                document.cookie = `isTrialAccount=true; expires=${dateToExpireCookie}`;
                const {REMAINING_EMAIL: emailLeft, REMAINING_DAYS: daysToExpire} = await $.ajaxDefaultQ({
                    url: '/CampaignCloud/Report/getTrialRemainingReport'
                });
                //if `-1` => account expired, if `0`, account expires in less than a day
                if (daysToExpire === -1 || emailLeft === 0) {
                    if (daysToExpire === -1) dhtmlx.alert(i18n.t("dashboard.expiredtrialaccount"));
                    else dhtmlx.alert(i18n.t("dashboard.nomoreemailtrialaccount"));
                } else {
                    //add `1` (to `daysToExpire`) to include the current day
                    dhtmlx.alert(i18n.t("dashboard.youstillhaveemailsdays", {
                        emails: emailLeft,
                        days: daysToExpire,
                        count: (daysToExpire + 1)
                    }));
                }
            }
        } catch (e) {
            this.render();
        }
    }

    @on('click a#logout-id')
    logout() {
        var url = '/CampaignCloud/logout';
        console.info('Logout...');

        $.ajaxDefaultQ({
            url: url,
            type: 'POST',
            dataType: "json"
        }).done(function () {
            document.cookie = "isTrialAccount=true; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            window.open('/CampaignCloud/cloudui/home/Login.htm', '_self');
        }).fail(function (response) {
            if (response.status === 403) {
                document.cookie = "isTrialAccount=true; expires=Thu, 01 Jan 1970 00:00:00 UTC";
                window.open('/CampaignCloud/cloudui/home/Login.htm', '_self');
                return;
            }
            console.info(`An error occurred during the logout ${response}`);
        });
    }

    @on('click .voucher-navbar-button')
    async voucherClick(ev) {
        var isRightLevel = true; //this.model.get("subscriptionLevel") > 0;  //todo revisit this if subscription levels change
        var isNotExpired = this.model.get("expirationDate") ? this.model.get("expirationDate").millis >= new Date() : true;

        if (isRightLevel && isNotExpired) {
            location.href = "Service.htm";
        } else {
            var titleText;
            var textText;
            var firstButton;

            if (!isNotExpired) {
                titleText = "profile.nopermissiontitle";
                textText = "profile.nopermissiontext";
                firstButton = "profile.nopermissionfirstbutton";
            }
            if (!isRightLevel) {
                titleText = "voucher.nopermissiontitle";
                textText = "voucher.nopermissiontext";
                firstButton = "voucher.nopermissionfirstbutton";
            }

            const result = await dhtmlx.modalbox({
                title: i18n.t(titleText),
                text: i18n.t(textText),
                buttons: [i18n.t(firstButton), i18n.t("cancelbtn")]
            });
            if (result === "0") {
                location.href = "Credits.htm";
            }
        }

        ev.preventDefault();
    }

    async goToContactsMap() {
        const resp = await $.ajaxDefaultQ({
            url: "/CampaignCloud/CreditsController/getActiveAddon",
            dataType: "json"
        });

        if (resp.outcome === "OK") {
            location.href = "/CampaignCloud/cloudui/home/ContactMap.htm";
        } else {
            const result = dhtmlx.confirm({
                text: i18n.t("dashboard.notactiveaddon"),
                ok: i18n.t("message.yes"),
                cancel: i18n.t("message.no")
            });
            if (result) {
                location.href = "/CampaignCloud/cloudui/home/Credits.htm";
            }

        }
    }

    @on('click #notifications-button')
    toggleNotifications() {
        var self = this;
        var $notificationsContainer = $(".notifications-container .notifications-content");
        var $notificationsButton = $("#notifications-button");

        //to show notifications
        if ($notificationsContainer.css("display") == "none") {
            $("#notifications-count").hide();
            $notificationsButton.addClass("fg-funkyOrange bg-white");

            var ids = [];
            var dataIds = $.each($(".notification-row"), (index, val) => {
                ids.push($(val).data("id"));
            });

            if (this.notificationsView.notificationCount && this.notificationsView.notificationCount > 0) {
                $.ajaxDefaultQ({
                    url: "/CampaignCloud/Notifications/markAsRead?ids=" + encodeURIComponent(ids.toString()),
                    type: "PUT"
                }).done(function (response) {
                    self.notificationsView.notificationCount = self.notificationsView.getNotificationCount();
                }).fail(function (response) {
                    console.error("Resp: ", response);
                });
            }
        } else { //to hide notifications
            if (this.notificationsView.notificationCount > 0) {
                $("#notifications-count").show();
                this.notificationsView.redrawNotifications();
            }

            $notificationsButton.removeClass("fg-funkyOrange bg-white");
        }
        $(".notifications-container .notifications-content").slideToggle("slow");
    }
}

export default NavbarView;
